exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".container-fluid {\n    min-height: 100%;\n}\n\n.box-shadow {\n    box-shadow: 0px 1px 5px 1px rgba(0, 0, 0, 0.4);\n}\n\nlabel {\n    color: #75798c;\n    font-weight: bold;\n    letter-spacing: 2px;\n}\n\n.btn-login {\n    color: #ffffff;\n    font-weight: bold;\n    letter-spacing: 2px;\n    background-color: #68b0ff;\n    font-size: 14px;\n    border-color: #68b0ff;\n}\n\n.btn-login:hover {\n    background-color: #5894d7;\n    border-color: #5894d7;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/_shared/login-view/login-view.component.css
// module id = 739
// module chunks = 0